import { render, staticRenderFns } from "./BarcodeAddNew.vue?vue&type=template&id=38d5a061&scoped=true&"
import script from "./BarcodeAddNew.vue?vue&type=script&lang=js&"
export * from "./BarcodeAddNew.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeAddNew.vue?vue&type=style&index=0&id=38d5a061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5a061",
  null
  
)

export default component.exports